module.exports = __webpack_public_path__ + "img/close.e0b028bd.svg";